export default {
  translation: {
    "OrderList.Header.Title": "내 주문 목록",
      "OrderList.Input.Search": "주문 번호...",
      "OrderList.Label.Status": "Spocket 상태별 정렬",
  
      "order.status.unpaid": "미결제",
      "order.status.paid": "결제 완료",
      "order.status.processing": "처리 중",
      "order.status.shipped": "배송 완료",
      "order.status.cancelled": "취소됨",
      "order.status.pending": "대기 중",
      "order.status.partially_paid": "일부 결제 완료",
      "order.status.partially_refunded": "일부 환불 완료",
      "order.status.refunded": "환불 완료",
      "order.status.voided": "무효 처리됨",
      "order.status.authorized": "승인 완료",
      "order.status.deleted": "삭제됨",
      "order.status.pending_payment_confirmation": "대기 중",
  
      "OrderList.Label.DownloadHistory": "모든 주문 내역 CSV로 다운로드",
      "OrderList.Document.Title": "주문 내역 - Spocket",
      "OrderList.EmptyOrders.Link.SearchProducts": "제품 검색",
      "OrderList.EmptyOrders.Tip.HowToProcessOrders": "주문 처리 방법",
      "OrderList.EmptyOrders.Message.Loading.Title": "주문 내역을 불러오고 있습니다!",
      "OrderList.EmptyOrders.Message.Loading.Description": "주문 내역을 찾는 동안 잠시만 기다려주세요.",
      "OrderList.EmptyOrders.Message.Title": "주문 목록이 비어있습니다!",
      "OrderList.EmptyOrders.Message.Description": "이곳에서 주문 내역을 관리하고 처리할 수 있습니다. 가져오기 목록에 제품을 추가하려면 검색 페이지로 이동하세요.",
      "OrderList.CheckBox.SelectAllOrders": "모든 주문 선택",
      "OrderList.CheckBox.SelectedXOrders": "{{count}} 주문 선택됨",
      "OrderList.CheckBox.SelectedXOrders_plural": "{{count}} 주문 선택됨",
      "OrderList.CheckBox.BulkCheckoutOrders": "대량 결제 주문",
      "OrderList.CheckBox.BulkCheckoutOrders_plural": "대량 결제 주문",
  
      "RefreshModal.Button.SynchronizeOrders": "주문 내역 동기화",
      "RefreshModal.Button.Cancel": "취소",
      "RefreshModal.Button.Synchronize": "동기화",
      "RefreshModal.Modal.Body": "내 스토어의 주문 내역이 자동으로 동기화되었습니다. 주문 정보가 누락되거나 업데이트되지 않은 경우에만 동기화합니다. 30초 후에 페이지를 새로고침해 주세요.",
  
      "Order.Label.OrderNumber" : "주문 번호",
      "Order.Label.Date" : "날짜",
      "Order.Label.OrderStatus" : "{{integrationName}} 주문 상태",
      "Order.Table.Th.Product" : "제품",
      "Order.Table.Th.Qty" : "수량",
      "Order.Table.Th.UnitPrice" : "단가",
      "Order.Table.Th.CheckoutDate" : "결제일",
      "Order.Table.Th.Action" : "조치",
  
      "CustomerModal.Button.ViewCustomerInfo": "고객 정보 확인",
      "CustomerModal.Modal.Title.CustomerInfo": "고객 정보",
      "CustomerModal.Modal.Body.CustomerInfo": "고객 정보",
      "CustomerModal.Modal.Body.Address": "주소",
  
      "OrderLine.Button.Checkout": "결제",
      "OrderLine.Tooltip.PreviewInvoice": "송장 미리 보기",
      "OrderLine.Tooltip.PaymentReceipt": "결제 영수증",
      "OrderLine.Tooltip.TrackOrder": "주문 추적",
      "OrderLine.Tooltip.OrderProcessing": "주문 처리 중",
      "OrderLine.Tooltip.OrderCancelled": "주문 취소됨",
      "OrderLine.Tooltip.PleaseConfirm": "해당 주문 내역의 결제를 확인하려면 클릭하세요",
      "OrderLine.Label.PurchaseEtsy": "Etsy에서 구매",
      "OrderLine.Paying": "결제 중",
      "OrderLine.Failure": "실패",
      "OrderLine.Sample": "샘플",
      "OrderLine.ErrorOrderRow": "시스템에서 주문 목록을 찾을 수 없습니다! 고객 지원팀에 문의해 주세요!",
  
      "ConfirmationModal.Label.OrderDetails": "주문 세부 정보",
      "ConfirmationModal.Label.Total": "합계",
      "ConfirmationModal.Label.Shipping": "배송",
      "ConfirmationModal.Label.TransactionFees": "거래 수수료",
      "ConfirmationModal.Tooltip.TransactionFees": "거래 수수료에는 Spocket의 결제업체인 Stripe에서 부과하는 수수료 및 서비스 수수료가 포함됩니다.",
      "ConfirmationModal.Modal.OrderConfirmation": "주문 확인",
      "ConfirmationModal.Modal.Alert.Attention": "주의!",
      "ConfirmationModal.Modal.Alert.Description": "해당 주문 건에는 고객의 메모가 포함되어 있습니다.",
      "ConfirmationModal.Modal.YoureAboutToPlaceOrder": "다음 사항을 주문하려 합니다.",
      "ConfirmationModal.Modal.Table.Th.Name": "이름",
      "ConfirmationModal.Modal.Table.Th.Price": "가격",
      "ConfirmationModal.Modal.Table.Th.Qty": "수량",
      "ConfirmationModal.Modal.Table.Th.Total": "합계",
      "ConfirmationModal.Modal.Label.Note": "공급업체 참고 사항",
      "ConfirmationModal.Modal.PlaceHolder.Note": "내 메시지",
      "ConfirmationModal.Button.PlaceOrder": "주문하기",
  
      "PaymentCompleteModal.PaymentCompleted": "결제 완료",
      "PaymentCompleteModal.PaymentCompleted.Note": "결제해 주셔서 감사합니다. 공급업체에 주문 내역을 통보했으며 곧 처리될 예정입니다. 주문 상태를 업데이트하고 주문 페이지에서 송장 번호를 추가할 예정입니다.",
      "PaymentCompleteModal.PaymentIncomplete": "주문이 완료되지 않았습니다!",
      "PaymentCompleteModal.PaymentIncomplete.BankRequiresConfirmation.Note": "계속 진행하려면 은행의 결제 확인이 필요합니다",
      "PaymentCompleteModal.PaymentIncomplete.ConfirmationLink": "결제를 확인하려면 이 링크를 사용해 주세요.",
      "PaymentCompleteModal.PaymentIncomplete.Note": "결제가 확인되면 공급업체에 통보하여 주문이 정상적으로 처리됩니다. 주문 페이지에 상태 및 추적 업데이트가 추가됩니다. 확인 후 해당 페이지를 새로고침해 주세요.",
  
      "SetYourGoalsModal.Title": "스토어에 추가된 제품 개수",
      "SetYourGoalsModal.Subtitle": "일반적인 스토어는 판매 전에 제품 25개를 올립니다",
      "SetYourGoalsModal.DropdownItem.Product": "제품 {{count}}개",
      "SetYourGoalsModal.DropdownItem.Product_plural": "제품 {{count}}개",
      "SetYourGoalsModal.Button": "목표를 설정하고 드랍쉬핑을 시작하세요",
  
      "YourGoalsBanner.Container.Description": "내 목표",
      "YourGoalsBanner.Header.Title": "비즈니스 시작하기",
      "YourGoalsBanner.Header.Subtitle": "내 스토어를 준비하세요",
      "YourGoalsBanner.Progress.Completed": "완료됨",
      "YourGoalsBanner.ProductPushedCount": "&lt;0>목표: {{goalsNumberOfProduct}}&lt;/0>제품 올리기",
      "YourGoalsBanner.CheckPoints.JoinSpocket": "Spocket 가입",
      "YourGoalsBanner.CheckPoints.FirstSearch": "첫 번째 검색",
      "YourGoalsBanner.CheckPoints.ProductsPushed": "제품 {{goalsNumberOfProduct}}개 중 {{count}}개 올림",
      "YourGoalsBanner.CheckPoints.ProductsPushed_plural": "제품 {{goalsNumberOfProduct}}개 중 {{count}}개 올림",
      "YourGoalsBanner.CheckPoints.ProductsImported": "제품 {{goalsNumberOfProduct}}개 중 {{count}}개 가져옴",
      "YourGoalsBanner.CheckPoints.ProductsImported_plural": "제품 {{goalsNumberOfProduct}}개 중 {{count}}개 가져옴",
  
      "Plan.Starter" : "스타터",
      "Plan.Professional": "프로페셔널",
      "Plan.Empire": "엠파이어",
      "Plan.Unicorn": "유니콘",
  
      "Aliscraper.Title": "자동화 AliExpress 드랍쉬핑",
      "Aliscraper.Subtitle": "클릭 한 번으로 수천 개의 Ali Express 제품을 온라인 스토어로 가져올 수 있으며, 배송 업무도 자동화할 수 있습니다.",
      "Aliscraper.Features.Feature1": "클릭 한 번으로 빠르게 가져오기",
      "Aliscraper.Features.Feature2": "Spocket을 통해 수백 개의 주문 즉시 처리",
      "Aliscraper.Features.Feature3": "연중무휴 고객 지원",
      "Aliscraper.Button": "확장 프로그램 다운로드",
      "Aliscraper.Chrome": "Chrome 웹 스토어에서 이용 가능",
  
      "ConnectStoreModal.Header.Title": "내 쇼핑몰 연결",
      "ConnectStoreModal.Footer.Text": "시작할 플랫폼 선택",
      "ConnectStoreModal.ShopifyForm.UrlText": "Shopify 스토어 URL",
      "ConnectStoreModal.ShopifyForm.InvalidName": "유효하지 않은 스토어 이름",
      "ConnectStoreModal.ShopifyForm.Placeholder": "예: MyStore",
      "ConnectStoreModal.ShopifyForm.FooterText": "아직 보유한 스토어가 없나요?",
      "ConnectStoreModal.ShopifyForm.FooterLink": "무료 체험하기",
      "ConnectStoreModal.ShopifyForm.Button": "스토어 연결하기",
      "ConnectStoreModal.WoocommerceInstruction.StoreIdText": "내 인증키:",
      "ConnectStoreModal.WoocommerceInstruction.Intro": "내 스토어를 Spocket에 연결하는 방법:",
      "ConnectStoreModal.WoocommerceInstruction.Step1": "Spocket 플러그인을",
      "ConnectStoreModal.WoocommerceInstruction.Step1Link": "여기에서 설치합니다",
      "ConnectStoreModal.WoocommerceInstruction.Step2": "내 플러그인 페이지에서 해당 플러그인을 활성화합니다",
      "ConnectStoreModal.WoocommerceInstruction.Step3": "WordPress 대시보드 > Spocket으로 이동합니다",
      "ConnectStoreModal.WoocommerceInstruction.Step4": "위에 언급된 인증키를 붙여넣고 \"저장\"을 클릭합니다",
      "ConnectStoreModal.WoocommerceInstruction.Trouble": "문제가 발생했나요?",
      "ConnectStoreModal.WoocommerceInstruction.TroubleLink": "문의하기",
      "ConnectStoreModal.WoocommerceInstruction.Button": "완료",
      "ConnectStoreModal.WixForm.FooterText": "아직 보유한 스토어가 없나요?",
      "ConnectStoreModal.WixForm.FooterLink": "무료 체험하기",
      "ConnectStoreModal.WixForm.Button": "스토어 연결하기",
      "ConnectStoreModal.FelexForm.FooterText": "아직 보유한 스토어가 없나요?",
      "ConnectStoreModal.FelexForm.FooterLink": "무료 체험하기",
      "ConnectStoreModal.FelexForm.Button": "스토어 연결하기",
      "ConnectStoreModal.BigcommerceForm.UrlText": "Bigcommerce 스토어 URL",
      "ConnectStoreModal.BigcommerceForm.InvalidName": "유효하지 않은 스토어 이름",
      "ConnectStoreModal.BigcommerceForm.Placeholder": "예: MyStore",
      "ConnectStoreModal.BigcommerceForm.FooterText": "아직 보유한 스토어가 없나요?",
      "ConnectStoreModal.BigcommerceForm.FooterLink": "무료 체험하기",
      "ConnectStoreModal.BigcommerceForm.Button": "스토어 연결하기",
  
      "PaymentTab.Document.Title": "설정 - 자동화 - Spocket",
      "PaymentTab.Title.Billing": "요금 청구",
      "PaymentTab.Tooltip.Billing": "주문 처리 및 구독 결제에 신용카드가 사용됩니다.",
      "PaymentTab.AccordionItem.PauseChangeYourPlan": "플랜 일시 중지 및 변경",
      "PaymentTab.AccordionItem.Label.ChangeYourPlan": "플랜 변경",
      "PaymentTab.AccordionItem.Button.Downgrade": "다운그레이드",
      "PaymentTab.AccordionItem.Label.PauseYourPlan": "플랜 일시 중지",
      "PaymentTab.AccordionItem.Label.StoreHasBeenPaused": "스토어가 이미 일시 중지 상태입니다",
      "PaymentTab.AccordionItem.Button.PauseYourPlan": "플랜 일시 중지",
      "PaymentTab.AccordionItem.Tooltip.PauseStore": "단기간 Spocket 계정을 일시 중지하고 데이터 손실 없이 언제든지 돌아올 수 있습니다.",
      "PaymentTab.AccordionItem.Label.RemindMeLater": "나중에 다시 알림",
      "PaymentTab.AccordionItem.Button.RemindMeLater": "나중에 다시 알림",
      "PaymentTab.AccordionItem.Tooltip.RemindMeLater.3DaysBefore": "3일 전",
      "PaymentTab.AccordionItem.Tooltip.RemindMeLater": "혜택을 유지하고 &lt;1>{{daysBefore}}&lt;/1>일 전에 멤버십 갱신 알림을 받습니다",
      "RemindMeLaterModal.Header.ReminderSet": "알림 설정 완료",
      "RemindMeLaterModal.Body.DaysBefore": "3일 전에 알림 이메일을 발송합니다",
      "RemindMeLaterModal.Body.ReminderSet": "알림이 설정되었으며 혜택 갱신 &lt;1>{{daysBefore}}&lt;/1>일 전에 알림이 발송됩니다. 그때까지 비즈니스 여정을 진행하세요.",
      "RemindMeLaterModal.Button.Continue": "계속",
      "PauseStoreModal.Title.PauseYourStore": "내 스토어 일시 중지",
      "PauseStoreModal.Description.PauseYourStore": "일회성 프로모션을 이용하여 향후 30일 동안 플랜 가격의 70% 할인 혜택을 받아보세요",
      "PauseStoreModal.Button.PauseStore": "스토어 일시 중지",
      "PauseStoreModal.Description.StorePaused": "스토어가 일시 중지되었으며 다음 달 구독 요금은 70% 할인됩니다. 이후에 정기 결제가 다시 진행됩니다.",
      "ConfirmPasswordModal.Title": "비밀번호를 확인해 주세요",
      "ConfirmPasswordModal.SubTitle": "보안상의 이유로 비밀번호 확인이 필요합니다",
      "ConfirmPasswordModal.Input.Placeholder": "내 비밀번호",
      "ConfirmPasswordModal.Button.Cancel": "취소",
      "ConfirmPasswordModal.Button.Confirm": "확인",
  
      "Config.MomentJs.Locale":"ko", 
      "Config.Plan.Starter":"스타터",
      "Config.Plan.Professional":"프로",
      "Config.Plan.Empire":"엠파이어",
      "Config.Plan.Unicorn":"유니콘",
  
      "UpgradeConfirmationModal.Header.Title":"Spocket과 함께 빠르게 성장하세요 ", 
      "UpgradeConfirmationModal.Body.Title":"결제 주기 선택",
      "UpgradeConfirmationModal.BulletPoints.Trial.Initial":"첫",
      "UpgradeConfirmationModal.BulletPoints.Trial.BeforeNumber":"", 
      "UpgradeConfirmationModal.BulletPoints.Trial.AfterNumber":"일 동안은 ", 
      "UpgradeConfirmationModal.BulletPoints.Trial.Final":"무료이며, 언제든지 취소할 수 있습니다",
      "UpgradeConfirmationModal.BulletPoints.FirstBill":"첫 번째 결제일은 다음과 같습니다",
      "UpgradeConfirmationModal.BulletPoints.FirstBillNoTrial":"첫 번째 결제는 확인 즉시 지불됩니다",
      "UpgradeConfirmationModal.BulletPoints.Recurrence":"결제는 매달 반복 청구됩니다",
      "UpgradeConfirmationModal.MonthlyTab.RateType":"월간 ", 
      "UpgradeConfirmationModal.MonthlyTab.RateFrequency":"/월",
      "UpgradeConfirmationModal.YearlyTab.RateType":"연간 ", 
      "UpgradeConfirmationModal.YearlyTab.RateFrequency":"/월",
      "UpgradeConfirmationModal.YearlyTab.Discount":"할인",
      "UpgradeConfirmationModal.TaxRates.Text":"판매세",
      "UpgradeConfirmationModal.TaxRates.Period":"월",
      "UpgradeConfirmationModal.YearlyPanel.PayNow":"지금 결제 시",
      "UpgradeConfirmationModal.YearlyPanel.PerMonth":"/월 X 12개월",
      "UpgradeConfirmationModal.YearlyPanel.Savings":"할인 적용: ", 
      "UpgradeConfirmationModal.YearlyPanel.Period":"/년",
      "UpgradeConfirmationModal.YearlyPanel.EquivalentInitial":"다음에 상응",
      "UpgradeConfirmationModal.YearlyPanel.EquivalentFinal":"% 할인",
      "UpgradeConfirmationModal.YearlyPanel.Warning.Trial":"연간 플랜에는 무료 체험 기간이 없습니다",
      "UpgradeConfirmationModal.YearlyPanel.Warning.Charge":"전액이 즉시 결제됩니다",
      "UpgradeConfirmationModal.CreditCardTab.Info":"신용/직불 카드 결제",
      "UpgradeConfirmationModal.PayPalTab.Info":"PayPal 결제",
      "UpgradeConfirmationModal.PaymentSection.Details":"결제 세부 정보 ", 
      "UpgradeConfirmationModal.CheckoutButton.FreeTrial":"무료 체험 혜택 받기",
      "UpgradeConfirmationModal.CheckoutButton.Upgrade":"다음으로 업그레이드: ", 
      "UpgradeConfirmationModal.FooterTestA.Info1.Top":"5만 명 이상의 사업가가 신뢰하는 브랜드",
      "UpgradeConfirmationModal.FooterTestA.Info1.Bottom":"고객 평가 5/5점 만점으로 지속적인 고객 만족.",
      "UpgradeConfirmationModal.FooterTestA.Info2.Top":"128비트 SSL 암호화",
      "UpgradeConfirmationModal.FooterTestA.Info2.Bottom":"모든 결제 정보는 100% 안전합니다.",
      "UpgradeConfirmationModal.FooterTestB.Avatars":"50,000+",
      "UpgradeConfirmationModal.FooterTestB.Info1.Top":"5만 명 이상의 사업가가 신뢰하는 브랜드",
      "UpgradeConfirmationModal.FooterTestB.Info1.Bottom":"고객 평가 5/5점 만점으로 지속적인 고객 만족.",
      "UpgradeConfirmationModal.FooterTestB.Info2.Top":"128비트 SSL 암호화",
      "UpgradeConfirmationModal.FooterTestB.Info2.Bottom":"모든 결제 정보는 100% 안전합니다.",
      "UpgradeConfirmationModal.Agreement.Intro":"진행하시려면 다음에 대한 동의가 필요합니다 " , 
      "UpgradeConfirmationModal.Agreement.Terms":"이용 약관",
      "UpgradeConfirmationModal.Agreement.Privacy":"개인정보 보호정책",
      "UpgradeConfirmationModal.Agreement.Refund":"환불 정책",
      "UpgradeConfirmationModal.Agreement.Middle":"및",
      "UpgradeConfirmationModal.Agreement.Cancelation":"취소 정책",
  
      "CreditCard.Update.Label":"신용카드",
      "CreditCard.Update.InputValue":"신용카드 만료 기간",
      "CreditCard.Update.Button":"카드 업데이트",
      "CreditCard.AddCreditCard.Text":"아직 추가된 신용카드가 없습니다. 주문을 자동으로 처리할 수 있도록 아래 버튼을 눌러 신용카드를 추가해 주세요",
      "CreditCard.AddCreditCard.Button":"신용카드 추가",
  
      "Sidebar.SearchProducts":"제품 검색",
      "Sidebar.WinningProducts":"우수한 제품",
      "Sidebar.WinningProducts.Variant":"신제품",
      "Sidebar.ImportList":"목록 가져오기",
      "Sidebar.MyProducts":"내 제품",
      "Sidebar.MyOrders":"내 주문",
      "Sidebar.Apps":"앱",
      "Sidebar.HelpCenter":"도움말 센터",
      "Sidebar.MyShop":"내 쇼핑몰",
      "Sidebar.Settings":"설정",
  
      "TutorialModal.Title":"언제든 도움을 드립니다",
      "TutorialModal.WhatIsSpocket":"Spocket은 무엇인가요?",
      "TutorialModal.DiscoverProducts":"제품 검색",
      "TutorialModal.ProductCustomization":"제품 맞춤 설정",
      "TutorialModal.OrderProcessing":"주문 처리 중",
      "TutorialModal.Settings":"설정",
      "TutorialModal.GetHelp":"도움말 보기",
      "TutorialModal.JoinTheCommunity":"커뮤니티 가입",
  
      "NotificationCenter.Header":"알림 센터",
      "NotificationCenter.Footer":"모든 알림 보기",
      "NotificationCenter.NoNotification":"새로운 알림이 없습니다!",
  
      "Products.Title.Head":"내 제품 - Spocket",
      "Products.Title.Header":"내 제품",
      "Products.Loading.Top":"제품 목록을 불러오는 중입니다!",
      "Products.Loading.Bottom":"제품 목록을 가져올 때까지 잠시만 기다려주세요.",
      "Products.Empty.Search":"제품을 찾을 수 없습니다!",
      "Products.Empty.Top":"제품 목록이 비어있습니다!",
      "Products.Empty.Bottom":"가져오기 목록에 제품을 추가하려면 검색 페이지로 이동하세요.",
      "Products.Empty.Button.Search":"제품 검색",
      "Products.Empty.Button.How":"제품 검색 방법",
      "Products.Alert.Removed":"제품 제거 완료",
  
      "Products.Search.Label":"제품을 검색하세요",
      "Products.Search.Placeholder":"키워드",
      "Products.Search.Button":"검색",
  
      "ProductListItem.Inactive.Tooltip":"해당 제품은 공급업체에서 제공하지 않습니다",
      "ProductListItem.Inactive.Title":"비활성",
      "ProductListItem.OutOfStock.Tooltip":"해당 제품의 모든 옵션이 품절되었습니다",
      "ProductListItem.OutOfStock.Title":"품절",
      "ProductListItem.InventoryCount.Singular":"개",
      "ProductListItem.InventoryCount.Plural":"개",
      "ProductListItem.InventoryCount.End.Singular":"남았음",
      "ProductListItem.InventoryCount.End.Plural":"남았음",
      "ProductListItem.Button.View":"스토어에 표시",
      "ProductListItem.Button.Remove":"스토어에서 제거",
  
      "ImportList.Title.Head":"목록 가져오기 - Spocket", 
      "ImportList.Title.Header":"내 가져오기 목록",
      "ImportList.Loading.Top":"가져오기 목록을 불러오고 있습니다!",
      "ImportList.Loading.Bottom":"제품 목록을 가져올 때까지 잠시만 기다려주세요.",
      "ImportList.Empty.Button.Search":"제품 검색",
      "ImportList.Empty.Top":"가져오기 목록이 비어있습니다!",
      "ImportList.Empty.Bottom":"가져오기 목록에 제품을 추가하려면 검색 페이지로 이동하세요.",
      "ImportList.Empty.Button.How":"제품 맞춤 설정 방법",
      "ImportList.Alert.Pushed":"다음 제품을 내 스토어에 올렸습니다.",
  
      "ImportList.Search.Label":"가져온 제품에서 검색하기",
      "ImportList.Search.Placeholder":"제품을 검색하세요",
      "ImportList.Search.Button":"검색",
  
      "PushAllModal.Button.Active":"현재 페이지의 제품 올리기",
      "PushAllModal.Button.Inactive":"현재 페이지 올리기",
      "PushAllModal.Modal.Text":"현재 페이지의 모든 제품을 올리시겠습니까? 현재 페이지의 모든 유효한 제품이 스토어에 올라갑니다.",
      "PushAllModal.Modal.Push":"모두 올리기",
      "PushAllModal.Modal.Cancel":"취소",
  
      "RemoveAllModal.Button.Active":"현재 페이지 제품 제거",
      "RemoveAllModal.Button.Inactive":"현재 페이지 제거",
      "RemoveAllModal.Modal.Text":"현재 페이지의 모든 제품을 제거하시겠습니까? 현재 페이지의 모든 제품이 가져오기 목록에서 제거됩니다.",
      "RemoveAllModal.Modal.Remove":"모두 제거",
      "RemoveAllModal.Modal.Cancel":"취소",
  
      "ImportListItem.Tab.Product":"제품",
      "ImportListItem.Tab.Description":"설명",
      "ImportListItem.Tab.Variants":"옵션",
      "ImportListItem.Tab.Images":"이미지",
      "ImportListItem.Remove.Active":"제품 제거하기",
      "ImportListItem.Remove.Inactive":"제품 제거",
      "ImportListItem.Push.Active":"스토어에 올리기",
      "ImportListItem.Push.Inactive":"스토어에 올리기",
      "ImportListItem.Save.Button":"저장",
      "ImportListItem.Alert.Removed":"다음 제품이 내 가져오기 목록에서 제거됩니다. ",
      "ImportListItem.Alert.RemoveFailed":"제거하는 중 다음과 같은 문제가 발생했습니다. ",
      "ImportListItem.Alert.CompareAtPrice":"비교 가격은 다음 판매 가격보다 커야 합니다. ",
      "ImportListItem.Alert.OneActiveVariation":"해당 제품에는 하나 이상의 활성 옵션이 필요합니다. ",
      "ImportListItem.Alert.Saved":"제품이 저장되었습니다. ",
      "ImportListItem.Alert.ErrorPushing":"스토어에 제품을 올리는 중 문제가 발생했습니다",
      "ImportListItem.Alert.ErrorSaving":"스토어를 저장하는 중 문제가 발생했습니다",
      "ImportListItem.Modal.ConnectStore":"스토어에 연결하여 제품 올리기: ",
      "ImportListItem.Tooltip.OneActiveVariation":"하나 이상의 활성 옵션이 필요합니다",
      "ImportListItem.Tooltip.Unavailable":"해당 제품은 현재 구매할 수 없습니다",
      "ImportListItem.Tooltip.Unsaved":"저장하지 않은 변경 사항이 있습니다",
      "ImportListItem.Tooltip.Profit":"경고: 해당 제품의 총 수익은 마이너스입니다",
      "ImportListItem.Tooltip.Unpurchasable":"제품을 저장할 수 있지만 현재 구매할 수 없습니다",
  
      "ItemInfo.ProductName.Label":"제품명",
      "ItemInfo.ProductTags.Label":"제품 태그",
      "ItemInfo.ProductTags.Remove":"모든 태그 제거",
      "ItemInfo.ProductTags.Placeholder":"새 태그 추가",
      "ItemInfo.ProductType.Label":"제품 유형",
      "ItemInfo.Collection.Label":"컬렉션",
      "ItemInfo.Collection.Placeholder":"선택",
      "ItemInfo.Collection.Option":"선택",
  
      "ItemVariantList.Modal.Title":"배송 정보",
      "ItemVariantList.Modal.Intro":"발송인: ",
      "ItemVariantList.Modal.DoesNotShipInternational":"해당 제품은 국제 배송이 불가합니다.",
      "ItemVariantList.Modal.DoesNotShipTo":"배송 불가 지역: ",
      "ItemVariantList.Table.Head.Destination":"배송지",
      "ItemVariantList.Table.Head.Cost":"비용",
      "ItemVariantList.Table.Head.Time":"배송 기간(일)",
      "ItemVariantList.Table.Body.Domestic":"국내",
      "ItemVariantList.Table.Body.International":"국제",
      "ItemVariantList.VariantsTable.ShippingPrice":"배송비 ", 
      "ItemVariantList.VariantsTable.Image":"이미지",
      "ItemVariantList.VariantsTable.SKU":"SKU",
      "ItemVariantList.VariantsTable.Inventory":"재고",
      "ItemVariantList.VariantsTable.Price":"가격",
      "ItemVariantList.VariantsTable.SalesPrice":"판매 가격 ", 
      "ItemVariantList.VariantsTable.Profit":"수익",
      "ItemVariantList.VariantsTable.CompareAtPrice":"비교 가격",
      "ItemVariantList.VariantsTable.Unavailable":"해당 제품은 현재 구매할 수 없습니다",
      "ItemVariantList.VariantsTable.Head":"해당 제품의 모든 옵션이 이곳에 표시됩니다.",
      "ItemVariantList.VariantsTable.ContextPopover.Placeholder":"예: 40%",
      "ItemVariantList.Alert.MaxVariants":"Shopify는 옵션이 100개 이상인 모델을 지원하지 않습니다.",
  
      "ItemVariantList.ContextPopover.Title":"수익 설정",
      "ItemVariantList.ContextPopover.Apply":"적용",
  
      "ProductVariation.Description": "Spocket에서 샘플을 직접 주문할 수 있습니다. 간편 결제를 진행하려면 아래의 단계를 따르세요.",
      "ProductVariation.Label.SelectVariant": "옵션 선택",
      "ProductVariation.Label.SelectTheProductVariation": "제품 옵션 선택",
      "ProductVariation.Qty": "수량",
      "ProductVariation.Label.NotesForTheSupplier": "공급업체 참고 사항",
  
      "InputAddress.Label.FirstName": "이름",
      "InputAddress.PlaceHolder.FirstName": "이름 입력",
      "InputAddress.Label.LastName": "성",
      "InputAddress.PlaceHolder.LastName": "성 입력",
      "InputAddress.Label.StreetAddress": "세부 주소",
      "InputAddress.Label.Country": "국가",
      "InputAddress.PlaceHolder.Country": "국가 검색",
      "InputAddress.Label.State": "주/도",
      "InputAddress.Placeholder.State": "주/도 검색",
      "InputAddress.Label.City": "시",
      "InputAddress.PlaceHolder.City": "시 입력",
      "InputAddress.Label.Zip": "우편번호",
      "InputAddress.PlaceHolder.Zip": "우편번호 입력",
      "InputAddress.Label.Phone": "전화번호",
      "InputAddress.Placeholder.Phone": "전화번호 입력",
  
      "OrderReview.OrderDetails": "주문 정보",
      "OrderReview.Unit": "{{count}}개",
      "OrderReview.Unit_plural": "{{count}}개",
      "OrderReview.ShippingAddress": "배송지 주소",
      "OrderReview.PaymentMethod": "결제 방식",
      "OrderReview.Amounts": "수량",
      "OrderReview.Subtotal": "소계",
      "OrderReview.ShippingCost": "배송비",
      "OrderReview.TransactionFees": "거래 수수료",
      "OrderReview.TransactionFees.ToolTips": "거래 수수료에는 Spocket의 결제업체인 Stripe에서 부과하는 수수료 및 서비스 수수료가 포함됩니다.",
      "OrderReview.OrderTotal": "총 주문 내역",
      "OrderReview.ItemWithCount": "{{count}}개",
      "OrderReview.ItemWithCount_plural": "{{count}}개",
      "OrderReview.Placeholder.CreditCard": "신용카드 만료 기간 {{last4}}",
  
      "PaymentComplete.PaymentCompleted": "결제 완료",
      "PaymentComplete.PaymentCompleted.Note": "결제해 주셔서 감사합니다. 공급업체에 주문 내역을 통보했으며 곧 처리될 예정입니다. 주문 상태를 업데이트하고 주문 페이지에서 송장 번호를 추가할 예정입니다.",
      "PaymentComplete.PaymentIncomplete": "주문이 완료되지 않았습니다!",
      "PaymentComplete.PaymentIncomplete.BankRequiresConfirmation.Note": "계속 진행하려면 은행의 결제 확인이 필요합니다",
      "PaymentComplete.PaymentIncomplete.ConfirmationLink": "결제를 확인하려면 이 링크를 사용해 주세요.",
      "PaymentComplete.PaymentIncomplete.Note": "결제가 확인되면 공급업체에 통보하여 주문이 정상적으로 처리됩니다. 주문 페이지에 상태 및 추적 업데이트가 추가됩니다. 확인 후 해당 페이지를 새로고침해 주세요.",
  
      "CreditCard.AddCreditCard.Description": "아직 추가된 신용카드가 없습니다. 주문을 자동으로 처리할 수 있도록 아래 버튼을 눌러 신용카드를 추가해 주세요",
      "CreditCard.Button.AddCreditCard": "신용카드 추가",
      "CreditCard.Button.UpdateCard": "카드 업데이트",
      "CreditCard.UpdateCard.Label.CreditCard": "신용카드",
      "CreditCard.PlaceHolder.CreditCard": "신용카드 만료 기간 {{last4}}",
  
      "UpdateCreditCardModal.Label.CreditCard": "신용카드",
      "UpdateCreditCardModal.Button.UpdateCard": "카드 업데이트",
      "UpdateCreditCardModal.Button.AddCreditCard": "신용카드 추가",
      "UpdateCreditCardModal.Button.Cancel": "취소",
      "UpdateCreditCardModal.Label.UpdateCardDetails": "카드 정보 업데이트",
      "UpdateCreditCardModal.Label.TermsAndConditionsNote.One": "Spockete 제품 주문 처리 중 귀하의 계정이 사용됩니다.",
      "UpdateCreditCardModal.Label.TermsAndConditionsNote.Two": "결제 처리",
      "UpdateCreditCardModal.Label.TermsAndConditionsNote.Three": "이용 약관.",
  
      "SampleOrderModal.Title.SelectVariation": "옵션 선택",
      "SampleOrderModal.Title.ShippingAddress": "배송지 주소",
      "SampleOrderModal.Title.PaymentMethod": "결제 수단",
      "SampleOrderModal.Title.Review": "리뷰",
      "SampleOrderModal.Title.PaymentConfirmationRequired": "결제 확인이 필요합니다!",
      "SampleOrderModal.Title.OrderPlaced": "주문이 완료되었습니다!",
      "SampleOrderModal.Steps": "{{total}}단계 중 {{current}}단계",
      "SampleOrderModal.FinalStep": "마지막 단계",
      "SampleOrderModal.ConfirmPayment": "결제 확인!",
      "SampleOrderModal.Finished": "완료",
      "SampleOrderModal.Footer.Continue": "계속",
      "SampleOrderModal.Footer.PlaceOrder": "주문하기",
      "SampleOrderModal.Footer.Close": "닫기",
      "SampleOrderModal.Footer.Cancel": "취소",
      "SampleOrderModal.Footer.GoBack": "뒤로",
  
      "RatingCaptureModal.EnjoyingSpocket": "Spocket이 마음에 드시나요?",
      "RatingCaptureModal.TapAStar": "앱스토어에서 별점으로 평가해주세요",
  
      "AdvancedFiltersModal.Title.Filters": "필터",
      "AdvancedFiltersModal.Title.Shipping": "배송",
      "AdvancedFiltersModal.Label.ShipsFrom": "발송지",
      "AdvancedFiltersModal.Label.ShipsTo": "배송지",
      "AdvancedFiltersModal.Label.ShippingTime": "배송 기간",
      "AdvancedFiltersModal.Label.Popular": "인기",
      "AdvancedFiltersModal.Label.Country.UnitedStates": "미국",
      "AdvancedFiltersModal.Label.Country.Europe": "유럽",
      "AdvancedFiltersModal.Label.ShippingTimeDescription": "미국으로만 배송 가능합니다",
      "AdvancedFiltersModal.RadioOption.ShippingTime.Any": "무관",
      "AdvancedFiltersModal.RadioOption.ShippingTime.One": "1-3일",
      "AdvancedFiltersModal.RadioOption.ShippingTime.Four": "4-7일",
      "AdvancedFiltersModal.RadioOption.ShippingTime.Eight": "8-14일",
      "AdvancedFiltersModal.RadioOption.ShippingTime.Fifteen": "15일 이상",
      "AdvancedFiltersModal.Title.ItemsCost": "제품 가격",
      "AdvancedFiltersModal.Label.ItemCost": "제품 가격",
      "AdvancedFiltersModal.Label.ShippingCost": "배송비",
      "AdvancedFiltersModal.RadioOption.ShippingCost.Any": "모든 비용",
      "AdvancedFiltersModal.RadioOption.ShippingCost.Free": "무료",
      "AdvancedFiltersModal.RadioOption.ShippingCost.Five": "5$ 이하",
      "AdvancedFiltersModal.RadioOption.ShippingCost.Fifteen": "15$ 이하",
      "AdvancedFiltersModal.RadioOption.ShippingCost.TwentyFive": "25$ 이하",
      "AdvancedFiltersModal.Title.Supplier": "공급업체",
      "AdvancedFiltersModal.Select.MenuTitle.Suppliers": "공급업체",
      "AdvancedFiltersModal.Label.TopSupplier": "인기 공급업체",
      "AdvancedFiltersModal.Label.TopSupplierDescription": "고품질 제품과 최고의 서비스, 높은 평점 리뷰로 유명한 공급업체",
      "AdvancedFiltersModal.Title.Advanced": "고급 설정",
      "AdvancedFiltersModal.Checkbox.Label.PremiumProducts": "프리미엄 제품",
      "AdvancedFiltersModal.Checkbox.Label.PremiumProductsDescription": "높은 할인율 및 빠른 배송 제품",
      "AdvancedFiltersModal.Checkbox.Label.BestSeller": "베스트셀러",
      "AdvancedFiltersModal.Checkbox.Label.BestSellerDescription": "Spocket의 최다 판매 제품",
      "AdvancedFiltersModal.Button.Cancel": "취소",
      "AdvancedFiltersModal.Button.ViewResults": "결과 보기",
      "AdvancedFiltersModal.Select.PlaceHolder.Countries": "국가 검색...",
      "AdvancedFiltersModal.Select.MenuTitle.Countries": "국가",
      "AdvancedFiltersModal.Select.PlaceHolder.Suppliers": "공급업체 검색...",
      "AdvancedFiltersModal.Label.All Suppliers": "모든 공급업체",
      "AdvancedFiltersModal.Label.New Suppliers": "신규 공급업체",
  
      "AdvancedFilters.ShippingTime.Any": "무관",
      "AdvancedFilters.ShippingTime.One": "1-3일",
      "AdvancedFilters.ShippingTime.Four": "4-7일",
      "AdvancedFilters.ShippingTime.Eight": "8-14일",
      "AdvancedFilters.ShippingTime.Fifteen": "15일 이상",
  
      "AdvancedFilters.ShippingCost.Free": "무료 배송",
      "AdvancedFilters.ShippingCost.Five": "배송비 5$ 이하",
      "AdvancedFilters.ShippingCost.Fifteen": "배송비 15$ 이하",
      "AdvancedFilters.ShippingCost.TwentyFive": "배송비 25$ 이하",
  
      "AdvancedFilters.transpileFiltersKey.Label.ClearAll": "모두 삭제",
      "AdvancedFilters.transpileFiltersKey.Label.Shipping": "배송",
      "AdvancedFilters.transpileFiltersKey.Label.Keywords": "검색",
      "AdvancedFilters.transpileFiltersKey.Label.ShipsFrom": "발송지",
      "AdvancedFilters.transpileFiltersKey.Label.ShipsTo": "배송지",
      "AdvancedFilters.transpileFiltersKey.Label.Supplier": "공급업체",
      "AdvancedFilters.transpileFiltersKey.Label.SortBy": "정렬 기준",
      "AdvancedFilters.transpileFiltersKey.Label.ItemCost": "제품 가격",
      "AdvancedFilters.transpileFiltersKey.Value.TopSuppliers": "인기 공급업체",
      "AdvancedFilters.transpileFiltersKey.Value.PersonalizedInvoices": "맞춤 송장",
      "AdvancedFilters.transpileFiltersKey.Value.BestSeller": "베스트셀러",
      "AdvancedFilters.transpileFiltersKey.Value.Premium": "프리미엄",
      "AdvancedFilters.transpileFiltersKey.Value.ItemCost.FromTo": "{{from}}~{{to}}",
  
      "Search.Header.PlaceHolder.Search": "키워드 검색...",
      "Search.Header.Button.Search": "검색",
      "Search.Header.Button.Filters": "필터",
  
      "Navigation.UpgradeButton.TryPro": "Spocket 프로 무료 체험하기",
      "Navigation.UpgradeButton.TryEmpire": "Spocket 엠파이어 무료 체험하기",
      "Navigation.UpgradeButton.TryUnicorn": "Spocket 유니콘 무료 체험하기",
  
      "CategoriesCards.Label.MoreCategories": "더 많은 카테고리",
  
      "StaticCategories.WomensClothing": "여성 의류",
      "StaticCategories.WomensClothing.Activewear": "액티브웨어",
      "StaticCategories.WomensClothing.Bodysuits": "바디수트",
      "StaticCategories.WomensClothing.Dresses": "드레스",
      "StaticCategories.WomensClothing.JacketsCoats": "재킷 &amp; 코트",
      "StaticCategories.WomensClothing.Jeans": "청바지",
      "StaticCategories.WomensClothing.JumpsuitsRompers": "점프수트 &amp; 롬퍼",
      "StaticCategories.WomensClothing.Leggings": "레깅스",
      "StaticCategories.WomensClothing.LingerieUnderwear": "란제리 &amp; 속옷",
      "StaticCategories.WomensClothing.MatchingSets": "상하의 세트",
      "StaticCategories.WomensClothing.Pants": "바지",
      "StaticCategories.WomensClothing.Shorts": "쇼츠",
      "StaticCategories.WomensClothing.Skirts": "스커트",
      "StaticCategories.WomensClothing.Sleepwear": "슬립웨어",
      "StaticCategories.WomensClothing.Socks": "양말",
      "StaticCategories.WomensClothing.SweatersHoodies": "스웨터 &amp; 후드",
      "StaticCategories.WomensClothing.Swimwear": "수영복",
      "StaticCategories.WomensClothing.TankTops": "탱크탑",
      "StaticCategories.WomensClothing.TopsBlouses": "탑 &amp; 블라우스",
      "StaticCategories.WomensClothing.Tshirts": "티셔츠",
  
      "StaticCategories.JewelryWatches": "주얼리 &amp; 시계",
      "StaticCategories.JewelryWatches.Bracelets": "팔찌",
      "StaticCategories.JewelryWatches.Earrings": "귀걸이",
      "StaticCategories.JewelryWatches.Necklaces": "목걸이",
      "StaticCategories.JewelryWatches.OtherAccessories": "기타 액세서리",
      "StaticCategories.JewelryWatches.PendantsStonesCharms": "펜던트 &amp; 원석 &amp; 참",
      "StaticCategories.JewelryWatches.Rings": "반지",
      "StaticCategories.JewelryWatches.Sets": "세트",
      "StaticCategories.JewelryWatches.Watches": "시계",
  
      "StaticCategories.TechAccessories": "전자 기기 액세서리",
      "StaticCategories.TechAccessories.AudioVideo": "오디오 &amp; 비디오",
      "StaticCategories.TechAccessories.CasesCovers": "케이스 &amp; 커버",
      "StaticCategories.TechAccessories.Lighting": "조명",
      "StaticCategories.TechAccessories.MobileLaptopAccessories": "모바일 기기 &amp; 노트북 액세서리",
      "StaticCategories.TechAccessories.Mousepads": "마우스패드",
      "StaticCategories.TechAccessories.Novelty": "특이한 제품",
  
      "StaticCategories.KidsBabies": "어린이 &amp; 유아",
      "StaticCategories.KidsBabies.BabyClothing": "유아복",
      "StaticCategories.KidsBabies.Bathing": "침구류",
      "StaticCategories.KidsBabies.BlanketsPillows": "이불 &amp; 베개",
      "StaticCategories.KidsBabies.CapsHeadbands": "모자 &amp; 헤어밴드",
      "StaticCategories.KidsBabies.Footwear": "신발",
      "StaticCategories.KidsBabies.Furniture": "가구",
      "StaticCategories.KidsBabies.KidsClothing": "어린이 의류",
      "StaticCategories.KidsBabies.ParenthoodAccessories": "육아 제품 &amp; 액세서리",
  
      "StaticCategories.Toys": "장난감",
      "StaticCategories.Footwear": "신발",
      "StaticCategories.Footwear.Boots": "부츠",
      "StaticCategories.Footwear.Flats": "플랫 슈즈",
      "StaticCategories.Footwear.Heels": "하이힐",
      "StaticCategories.Footwear.Mens": "남성용",
      "StaticCategories.Footwear.Sandals": "샌들",
      "StaticCategories.Footwear.Slippers": "슬리퍼",
      "StaticCategories.Footwear.SneakersRunners": "스니커즈 &amp; 러닝화",
  
      "StaticCategories.BathBeauty": "목욕 &amp; 뷰티",
      "StaticCategories.BathBeauty.Bodycare": "바디케어",
      "StaticCategories.BathBeauty.DiffusersOilsCandles": "디퓨저 &amp; 오일 &amp; 캔들",
      "StaticCategories.BathBeauty.Haircare": "헤어케어",
      "StaticCategories.BathBeauty.Healthcare": "헬스케어",
      "StaticCategories.BathBeauty.Makeup": "메이크업",
      "StaticCategories.BathBeauty.Nails": "네일",
      "StaticCategories.BathBeauty.Skincare": "스킨케어",
      "StaticCategories.BathBeauty.TowelsRobes": "타월 &amp; 가운",
  
      "StaticCategories.Pets": "반려동물",
      "StaticCategories.Pets.BedsBlankets": "침구 &amp; 이불",
      "StaticCategories.Pets.LeashesCollarsPetwear": "목줄 &amp; 반려동물 의류",
      "StaticCategories.Pets.Petcare": "반려동물 용품",
      "StaticCategories.Pets.Toys": "장난감",
  
      "StaticCategories.HomeGarden": "실내 &amp; 정원",
      "StaticCategories.HomeGarden.Bathroom": "욕실",
      "StaticCategories.HomeGarden.Clocks": "시계",
      "StaticCategories.HomeGarden.Drinkware": "컵",
      "StaticCategories.HomeGarden.FoodBeverage": "음식 &amp; 음료",
      "StaticCategories.HomeGarden.Furniture": "가구",
      "StaticCategories.HomeGarden.Garden": "정원",
      "StaticCategories.HomeGarden.HomeDecor": "홈 데코",
      "StaticCategories.HomeGarden.HomeImprovement": "홈 레노베이션",
      "StaticCategories.HomeGarden.Kitchen": "부엌",
      "StaticCategories.HomeGarden.Lighting": "조명",
      "StaticCategories.HomeGarden.Organization": "정리",
      "StaticCategories.HomeGarden.StationeryCrafts": "문구류 &amp; 공예",
      "StaticCategories.HomeGarden.TextilesPillows": "텍스타일 &amp; 쿠션",
      "StaticCategories.HomeGarden.Tools": "도구",
  
      "StaticCategories.Accessories": "액세서리",
      "StaticCategories.Accessories.Belts": "벨트",
      "StaticCategories.Accessories.Cufflinks": "커프스",
      "StaticCategories.Accessories.Hats": "모자",
      "StaticCategories.Accessories.Keychains": "키체인",
      "StaticCategories.Accessories.ScarvesBandanas": "스카프 &amp; 반다나",
      "StaticCategories.Accessories.Sunglasses": "선글라스",
  
      "StaticCategories.MensClothing": "남성복",
      "StaticCategories.MensClothing.Activewear": "액티브웨어",
      "StaticCategories.MensClothing.DressShirts": "드레스 셔츠",
      "StaticCategories.MensClothing.JacketsCoats": "재킷 &amp; 코트",
      "StaticCategories.MensClothing.Pants": "바지",
      "StaticCategories.MensClothing.Shorts": "쇼츠",
      "StaticCategories.MensClothing.Socks": "양말",
      "StaticCategories.MensClothing.SweatersHoodies": "스웨터 &amp; 후드",
      "StaticCategories.MensClothing.Swimwear": "수영복",
      "StaticCategories.MensClothing.TankTops": "탱크탑",
      "StaticCategories.MensClothing.Tshirts": "티셔츠",
      "StaticCategories.MensClothing.Underwear": "속옷",
  
      "StaticCategories.SportsOutdoors": "스포츠 &amp; 아웃도어",
      "StaticCategories.SportsOutdoors.Activewear": "액티브웨어",
      "StaticCategories.SportsOutdoors.Biking": "자전거용품",
      "StaticCategories.SportsOutdoors.Camping": "캠핑용품",
      "StaticCategories.SportsOutdoors.EquipmentAccessories": "장비 &amp; 액세서리",
      "StaticCategories.SportsOutdoors.Fishing": "낚시용품",
  
      "StaticCategories.Gifts": "선물",
      "StaticCategories.Gifts.Adults": "성인용품",
      "StaticCategories.Gifts.Funny": "재밌는 제품",
      "StaticCategories.Gifts.Mugs": "머그컵",
      "StaticCategories.Gifts.Novelty": "특이한 제품",
      "StaticCategories.Gifts.Personalized": "개인",
      "StaticCategories.Gifts.Religious": "종교",
  
      "StaticCategories.Automotive": "자동차용품",
      "StaticCategories.BagsWallets": "가방 &amp; 지갑",
      "StaticCategories.Seasonal": "시즌 제품",
      "StaticCategories.Seasonal.Christmas": "크리스마스",
      "StaticCategories.Seasonal.FathersDay": "아버지의 날",
      "StaticCategories.Seasonal.Halloween": "핼러윈",
      "StaticCategories.Seasonal.MothersDay": "어머니의 날",
  
      "StaticCategories.FestivalsParties": "축제 &amp; 파티",
      "StaticCategories.FestivalsParties.PartySupplies": "파티 제품",
      "StaticCategories.FestivalsParties.Wedding": "웨딩",
  
      "QuickFilters.Label.ShipsFromUSA": "미국에서 배송",
      "QuickFilters.Label.ShipsFromEU": "유럽에서 배송",
      "QuickFilters.Label.Premium": "프리미엄",
      "QuickFilters.Label.FastUSAShipping": "빠른 미국 배송",
      "QuickFilters.Label.Under5": "5$ 이하의 미국 배송",
  
      "SortBy.Label.SortBy": "정렬 기준",
      "SortBy.DropDown.Item.Relevance": "관련성",
      "SortBy.DropDown.Item.PriceLowToHigh": "가격: 낮은 가격부터",
      "SortBy.DropDown.Item.PriceHighToLow": "가격: 높은 가격부터",
      "SortBy.DropDown.Item.Newest": "최신",
      "SortBy.DropDown.Item.ShippingTime": "배송 기간",
  
      "Breadcrumb.Item.Home": "홈",
      "Breadcrumb.Item.Search": "검색",
  
      "UpgradeModal.Modal.Title": "요금 플랜 선택",
  
      "Plans.ToggleSection.Monthly": "월간",
      "Plans.ToggleSection.Yearly": "연간",
      "Plans.ToggleSection.DiscountInitial": "최대",
      "Plans.ToggleSection.DiscountSingular": "개월",
      "Plans.ToggleSection.DiscountPlural": "개월",
      "Plans.ToggleSection.DiscountFinal": "할인",
      "Plans.ProrationCost.TextInitial": "현재 결제 금액은",
      "Plans.ProrationCost.TextFinal": "/년입니다. 다음 추가 기간에 한해 엠파이어로 업그레이드",
  
      "Card.Title.PeriodSingular": "개월",
      "Card.Title.PeriodPlural": "개월",
      "Card.Title.Off": "할인",
      "Card.DescriptionVariantType.Starter": "판매 시작",
      "Card.DescriptionVariantType.Professional": "판매 촉진",
      "Card.DescriptionVariantType.Empire": "판매 극대화",
      "Card.DescriptionVariantType.Unicorn": "규모별 판매 관리",
      "Card.DescriptionVariantType.Period": "월",
      "Card.DescriptionVariantType.PricePeriod": "{{value}}/월",
      "Card.DescriptionVariantType.AnnualDescription": "연간 결제 금액 {{value}}$가",
      "Card.DescriptionVariantType.MonthlyDescription": "{{value}}일 무료 체험 이후에 청구됩니다",
      "Card.DescriptionVariantType.CurrentPlan": "현재 플랜",
      "Card.DescriptionVariantType.AnnualButton.Starter": "지금 시작하기",
      "Card.DescriptionVariantType.MonthlyButton.Starter": "무료 체험하기",
      "Card.DescriptionVariantType.AnnualButton.Professional": "지금 시작하기",
      "Card.DescriptionVariantType.MonthlyButton.Professional": "무료 체험하기",
      "Card.DescriptionVariantType.AnnualButton.Empire": "지금 시작하기",
      "Card.DescriptionVariantType.MonthlyButton.Empire": "무료 체험하기",
      "Card.DescriptionVariantType.AnnualButton.Unicorn": "지금 시작하기",
      "Card.DescriptionVariantType.MonthlyButton.Unicorn": "무료 체험하기",
      "Card.DescriptionVariantType.UniqueProducts": "독특한 제품",
      "Card.DescriptionVariantType.PremiumProducts": "프리미엄 제품",
      "Card.DescriptionVariantType.EmailSupport": "이메일 지원",
      "Card.DescriptionVariantType.Invoicing": "브랜드 송장",
      "Card.DescriptionVariantType.InvoicingTooltip": "브랜드 송장을 제공하는 공급업체의 모든 주문에 나만의 로고를 추가하여 브랜드를 구축할 수 있습니다",
      "Card.DescriptionVariantType.ChatSupport": "채팅 지원",
      "Card.DescriptionVariantType.WinningProducts": "우수한 제품",
      "Card.DescriptionVariantType.SupplierSourcing": "공급업체 소싱",
      "Card.DescriptionVariantType.ProductRequests": "제품 요청",
      "Card.DescriptionVariantType.ProductRequestsTooltip": "아직 Spocket에 없는 제품 요청",
      "Card.DescriptionVariantType.BulkCheckout": "대량 결제",
      "Card.DescriptionVariantType.BulkCheckoutTooltip": "한 번의 버튼 클릭으로 여러 개의 주문을 결제하세요",
      "Card.DescriptionVariantType.Special": "스페셜",
  
      "ReactivationBanner.Alert": "Spocket 구독이 만료되었습니다.",
      "ReactivationBanner.InfoSubtitle": "다시 활성화하기",
      "ReactivationBanner.CheckList.HighQuality": "고품질",
      "ReactivationBanner.CheckList.Curated": "엄선된",
      "ReactivationBanner.CheckList.FastShipping": "빠른 배송",
      "ReactivationBanner.CheckList.FromUSAndEU": "미국 및 유럽에서 발송",
      "ReactivationBanner.TextByPlan.Starter.Description": "더 이상 &lt;1>제품을 올릴 수&lt;/1> 없습니다",
      "ReactivationBanner.TextByPlan.Starter.Title": "Spocket 계정",
      "ReactivationBanner.TextByPlan.Starter.Subtitle": "지금 내 스토어에 제품 올리기",
      "ReactivationBanner.TextByPlan.Others.Description.PartOne": "더 이상 실시간으로 &lt;1>제품을 올릴 수&lt;/1> 없거나  ",
      "ReactivationBanner.TextByPlan.Others.Description.PartTwo": "프리미엄 제품을 사용할 수 없습니다",
      "ReactivationBanner.TextByPlan.Others.Title": "프리미엄 계정",
      "ReactivationBanner.TextByPlan.Others.Subtitle": "다음과 같은 프리미엄 제품 이용 가능",
      "ReactivationBanner.Button": "지금 내 계정 다시 활성화하기",
  
      "AnnualPromotionModal.Header": "축하합니다. {{planName}} 플랜을 구독하셨습니다.",
      "AnnualPromotionModal.CountdownTitle": "만료일",
      "AnnualPromotionModal.Button.Yes": "연간 구독으로 업그레이드",
      "AnnualPromotionModal.Button.No": "아니요, 월간 플랜 구독을 유지하겠습니다",
  
      "UpgradeReasonModal.Benefits.IncreasedProducts": "더 많은 제품 올리기",
      "UpgradeReasonModal.Benefits.UnlimitedOrders": "무제한 주문",
      "UpgradeReasonModal.Benefits.BrandedInvoicing": "브랜드 송장",
      "UpgradeReasonModal.Benefits.PremiumProducts": "프리미엄 제품을 사용할 수 없습니다",
      "UpgradeReasonModal.Benefits.ExclusiveDeals": "특별 할인가",
      "UpgradeReasonModal.Benefits.ChatCallSupport": "채팅 &amp; 전화 지원",
      "UpgradeReasonModal.Modal.Title": "Spocket에서 달성하려는 목표는 무엇인가요?",
      "UpgradeReasonModal.Modal.Question": "업그레이드 계기는 무엇인가요?",
      "UpgradeReasonModal.Modal.Button": "Spocket {{plan}} 이용 시작하기",
      "UpgradeReasonModal.UpgradeComment.PlaceHolder": "여러분의 이용 경험을 개선하는 데 도움이 됩니다",
  
      "UpgradeSuccessModal.Col.One.A": "축하합니다.",
      "UpgradeSuccessModal.Col.One.B": "{{alias}} 플랜을 구독하셨습니다!",
      "UpgradeSuccessModal.Col.Two.A": "성공적인 드랍쉬핑 비즈니스를 구축하기 위해 필요한 모든 도구를 이용하실 수 있습니다.",
      "UpgradeSuccessModal.Col.Two.B": "이제 다음이 지원됩니다 ",
      "UpgradeSuccessModal.Col.Two.C": " Spocket을 즐겨보세요!",
      "UpgradeSuccessModal.Button": "계속",
  
      "Promotion.TrialDaysNormalizer.30days": "1개월",
      "Promotion.TrialDaysNormalizer.28days": "4주",
      "Promotion.TrialDaysNormalizer.21days": "3주",
      "Promotion.TrialDaysNormalizer.14days": "2주",
      "Promotion.TrialDaysNormalizer.7days": "1주",
      "Promotion.TrialDaysNormalizer.1day": "1일",
      "Promotion.TrialDaysNormalizer.Days": "{{value}}일",
      "Promotion.TrialDaysPlan.Title": "지금 Spocket 프로 구독을 시작하고 2주 동안 무료로 사용해 보세요!",
      "Promotion.TrialDaysPlan.Text": "지금 Spocket 프로페셔널을 시작하고 {{value}} 동안 무료로 사용해 보세요!",
      "Promotion.Button": "무료 체험하기",
      "StickyPromotion.Text": "다음 기간 동안 Spocket 프로 구독 무료 체험",
      "StickyPromotion.Button": "지금 무료 체험하기 →",
      "Onboarding.Steps.Title": "내 스토어의 판매 실적을 높여보세요!",
      "Onboarding.Steps.Subtitle": "Spocket 팁: 일반적인 스토어는 판매 전에 제품 25개를 올립니다",
      "Steps.ChecklistItem.Connect.Text": "내 계정 연결",
      "Steps.ChecklistItem.Connect.Tooltip": "내 계정을 Shopify 또는 WooCommerce 스토어에 연결합니다",
      "Steps.ChecklistItem.Connect.Disabled": "",
      "Steps.ChecklistItem.Search.Text": "제품 검색 &amp; 가져오기 목록에 추가",
      "Steps.ChecklistItem.Search.Tooltip": "미국/유럽 기반의 공급업체에서 근사한 제품을 찾아 가져오기 목록에 추가합니다.",
      "Steps.ChecklistItem.Search.Disabled": "",
      "Steps.ChecklistItem.Push.Text": "내 스토어에 제품 올리기",
      "Steps.ChecklistItem.Push.Tooltip": "내 가져오기 목록에 있는 제품을 맞춤 설정하여 한 번의 클릭으로 스토어에 올릴 수 있습니다.",
      "Steps.ChecklistItem.Push.Disabled": "",
      "Steps.ChecklistItem.Review.Text": "Spocket 리뷰를 남겨주세요!",
      "Steps.ChecklistItem.Review.Tooltip": "즐겁게 사용하고 계신가요? 여러분의 의견을 들려주세요!",
      "Steps.ChecklistItem.Review.Disabled": "계정 연결",
  
      "BubbleWidget.Head.Title":"안녕하세요",
      "BubbleWidget.Head.Subtitle":"Spocket 고객 지원 센터에 오신 것을 환영합니다",
      "BubbleWidget.HelpCenter.Title":"도움말 센터",
      "BubbleWidget.HelpCenter.Subtitle":"Spocket 팀의 조언 및 답변",
      "BubbleWidget.EmailUs.Title":"이메일 문의",
      "BubbleWidget.EmailUs.Subtitle":"질문이 있으면 문의해 주세요",
      "BubbleWidget.ChatWithUs.Title":"채팅 문의",
      "BubbleWidget.ChatWithUs.Subtitle.Basic":"프로 &amp; 엠파이어 사용자 전용",
      "BubbleWidget.ChatWithUs.Subtitle.NotBasic":"지원 담당자가 대기 중입니다",
      "BubbleWidget.ChatWithUs.Subtitle.Unlock":"지금 잠금 해제하기",
      "BubbleWidget.Community.Title":"커뮤니티",
      "BubbleWidget.Community.Subtitle":"5만 명 이상의 드랍쉬핑 판매자들의 커뮤니티에 가입하세요",
      "BubbleWidget.StoreReviews.Title":"스토어 리뷰",
      "BubbleWidget.StoreReviews.Subtitle":"프로 &amp; 엠파이어 사용자",
      "BubbleWidget.StoreReviews.Unlock":"지금 잠금 해제하기",
      "Language.Title": "언어",
  
      "sidebar.menu.search_product": "제품 검색",
      "sidebar.menu.import_list": "목록 가져오기",
      "plans_cards.card": "판매 시작",
      "plans_cards.card.starter.price": "&lt;1>{{currency_symbol}}&lt;/1>",
  
      "WhatYouWillLoseModal.Button.Offer": "계속 유지하기",
      "WhatYouWillLoseModal.Button.Downgrade": "포기하고 계정 다운그레이드하기",
      "WhatYouWillLoseModal.ProductSection.Title": "&lt;1>{{product_count}}가져온 제품&lt;/1>이 모두 사라집니다",
      "WhatYouWillLoseModal.Product.PremiumTag": "프리미엄",
      "WhatYouWillLoseModal.Product.SkeletonImage": "{{product_count}}개 이상",
      "WhatYouWillLoseModal.ModalWrapper.Header": "벌써 포기하시나요?",
      "WhatYouWillLoseModal.ModalWrapper.Title.Tag": "50% 할인 혜택을 받으세요",
      "WhatYouWillLoseModal.ModalWrapper.Title": "다음 3개월 동안 비즈니스 여정을 이어가세요.",
      "WhatYouWillLoseModal.ModalWrapper.Subtitle": "여러분만의 성공 스토리를 만드시길 바랍니다. 이미 많은 시간을 투자하신 것을 알고 있습니다. 조금만 더 노력해 보세요. 저희가 응원하겠습니다. Spocket 팀",
  
      "FiftyOff3MonthsOfferSuccessModal.Header": "축하합니다. 다음 3개월 동안 구매하신 플랜에 50% 할인 혜택이 추가되었습니다!",
      "FiftyOff3MonthsOfferSuccessModal.Button": "계속",
  
      "DowngradeReasonModal.DowngradeSection": "어떻게 하면 Spocket의 사용 경험을 더욱 개선할 수 있을까요?",
      "DowngradeReasonModal.DowngradeSection.TextArea.PlaceHolder": "모든 것에 대한 피드백을 받고 있습니다(최소 100자)",
      "DowngradeReasonModal.DowngradeSection.Tooltip": "피드백을 입력해 주세요(최소 100자)",
      "DowngradeReasonModal.Button.Downgrade": "다운그레이드",
      "DowngradeReasonModal.ModalWrapper.Header": "{{storeName}} 다운그레이드를 진행할까요?",
      "DowngradeReasonModal.ModalWrapper.ContactUs": "문의하기",
      "DowngradeReasonModal.ModalWrapper.Footer.Button.Cancel": "취소",
  
      "DowngradeSuccessModal.Header": "다운그레이드 완료",
      "DowngradeSuccessModal.Body": "피드백을 보내주셔서 감사합니다. Spocket을 개선하기 위해 매일 노력하고 있습니다. 조만간 다시 기회를 주시면 감사하겠습니다!",
  
      "Settings.title": "설정",
      "Settings.buttonSaveChanges": "변경 사항 저장",
      "Settings.buttonSaveAndPreview": "저장 및 미리보기",
  
      "AccountTab.documentTitle": "설정 - 계정 - Spocket",
      "AccountTab.title": "계정 설정",
      "AccountTab.shopName": "쇼핑몰 이름",
      "AccountTab.email": "이메일",
      "AccountTab.shopUrl": "쇼핑몰 URL",
      "AccountTab.defaultCurrency": "기본 통화",
      "AccountTab.yourPlan": "내 플랜",
      "AccountTab.accountNotActive": "내 계정은 현재 활성 상태가 아닙니다",
      "AccountTab.alertFeatureWillBeAddedSoon": "해당 기능은 곧 추가될 예정입니다! 지금은 Spocket Shopify 앱을 사용하여 연결해 주세요!",
      "AccountTab.alertAccountSettingsUpdated": "계정 설정 업데이트 완료",
      "AccountTab.alertInvalidShopUrl": "유효하지 않은 쇼핑몰 URL",
      "AccountTab.productsImported": "가져온 제품",
      "AccountTab.products": "제품",
      "AccountTab.premiumProducts": "프리미엄 제품을 사용할 수 없습니다",
      "AccountTab.total": "합계",
      "AccountTab.signOut": "로그아웃",
      "AccountTab.limitReachedProductsAndPremium": "제품 및 프리미엄 제품 한도에 도달했습니다.",
      "AccountTab.limitReachedProducts": "제품 한도에 도달했습니다.",
      "AccountTab.limitReachedPremium": "프라미엄 제품 한도에 도달했습니다.",
      "AccountTab.buttonSwitchToAnnualPlan": "연간 플랜으로 변경하기",
      "AccountTab.off30Percent": "30% 할인",
      "AccountTab.off40Percent": "40% 할인",
      "AccountTab.off45Percent": "45% 할인",
      "AccountTab.sellMoreWithEmpirePlan": "엠파이어 플랜으로 판매 실적을 높여보세요",
      "AccountTab.tooltipCurrency":"통화는 스토어 계정에서 관리할 수 있습니다. 가져온 제품의 모든 가격이 해당 통화로 변경됩니다.",
      "AccountTab.shopNotConnectedYet": "쇼핑몰을 아직 해당 계정에 연결하지 않았습니다.",
      "AccountTab.connectYourShop": "쇼핑몰 연결",
  
      "InvoiceTab.documentTitle": "설정 - 송장 - Spocket",
      "InvoiceTab.alertInvoiceSettingSaved": "송장 설정이 저장되었습니다!",
      "InvoiceTab.shopLogo": "쇼핑몰 로고",
      "InvoiceTab.contactEmail": "이메일 문의",
      "InvoiceTab.phoneNumber": "전화번호",
      "InvoiceTab.personalNote": "개인 메모",
      "InvoiceTab.tooltipPersonalNote": "각 브랜드 송장에 삽입할 개인 메모를 설정합니다",
      "InvoiceTab.brandedInvoicing": "브랜드 송장",
      "InvoiceTab.tooltipBrandedInvoicing": "유료 플랜을 이용하면 브랜드 송장 제공 공급업체에서 주문한 모든 내역에 브랜드 로고 및 개인 메모를 추가할 수 있습니다",
      "InvoiceTab.disabledInvoicing": "모든 주문 내역에 브랜드 송장을 추가합니다",
      "InvoiceTab.tooltipDisabledInvoicing": "해당 옵션을 해제하면 주문 시 브랜드 송장이 제외됩니다",
  
      "PricingTab.titleDefaultPricingRules": "가격 설정 기본 규칙",
      "PricingTab.tooltipTitleDefaultPricingRules": "이곳에서 모든 제품에 적용되는 고정 마크업 또는 배율을 할당할 수 있습니다",
      "PricingTab.titleAdvancedPricingRules": "가격 설정 고급 규칙",
      "PricingTab.tooltipTitleAdvancedPricingRules": "고급 규칙은 제품 가격 범위에 따라 마크업 또는 배율을 설정합니다.",
      "PricingTab.assignCents": "센트 지정",
      "PricingTab.tooltipAssignCents": "해당 값은 제품의 최종 가격을 표시할 때 사용됩니다(예: 제품 가격을 XX.99로 설정하려면 아래 필드에 99를 추가).",
      "PricingTab.Markup": "마크업",
      "PricingTab.MarkupType": "마크업 유형",
      "PricingTab.SelectDefault": "-- 1개 선택 --",
      "PricingTab.SelectPercent": "%",
      "PricingTab.SelectMultiplier": "배율",
      "PricingTab.SelectFixed": "고정",
      "PricingTab.titlePricingRules": "설정 - 가격 설정 규칙 - Spocket",
      "PricingTab.toggleAdvancedPricingRules": "가격 설정 고급 규칙 선택",
      "PricingTab.from": "최소",
      "PricingTab.to": "최대",
      "PricingTab.selectFixedAmount": "고정 가격",
      "PricingTab.buttonRemove": "제거",
      "PricingTab.alertCannotCreateMoreThanOneRuleWithEmptyFields": "필드가 비어 있으면 2개 이상의 규칙을 생성할 수 없습니다",
      "PricingTab.costRange": "가격 범위",
      "PricingTab.markup": "마크업",
      "PricingTab.add": "추가",
  
      "SecurityTab.Document.Title": "설정 - 보안 - Spocket",
      "SecurityTab.alertIncorrectPassword": "잘못된 비밀번호",
      "SecurityTab.title": "보안",
      "SecurityTab.yourNewPassword": "새 비밀번호",
      "SecurityTab.repeatPassword": "비밀번호 확인",
      "SecurityTab.errorPleaseEnterAPassword": "비밀번호를 입력해 주세요.",
      "SecurityTab.errorPasswordsConfirmationNeeded": "비밀번호를 다시 한 번 입력해 주세요.",
      "SecurityTab.errorPasswordsDoNotMatch": "비밀번호가 맞지 않습니다",
      "SecurityTab.errorPasswordShort": "비밀번호는 최소 8자로 설정해야 합니다",
  
      "currency_symbol": "$",
  
      "ListingCards.TopSupplierTag.Tooltip": "인기 공급업체는 고품질 제품, 최상의 서비스, 높은 평가로 유명합니다",
      "ListingCards.TopSupplierTag.Text": "공급업체",
  
      "ListingCard.OriginCountry.Intro":"기준",
      "ListingCard.OriginCountry.Tooltip":"발송지",
      "ListingCard.Shipping.Price.Title":"배송비",
      "ListingCard.Shipping.Price.Free":"무료",
      "ListingCard.Price.Intro":"가격",
      "ListingCard.Price.Retail":"소매가",
      "ListingCard.Shipping.Time.Title":"배송 기간",
      "ListingCard.Shipping.Time.Period":"일",
      "ListingCard.PremiumIcon.Tooltip":"내 쇼핑몰에서 할인율이 높으며 배송이 빠른 제품을 독점적으로 판매하세요",
      "ListingCard.PremiumIcon.Text":"프리미엄",
      "ListingCard.ListButton.Import":"가져오기 목록에 추가",
      "ListingCard.ListButton.Remove":"가져오기 목록에서 제거",
      "ListingCard.ListButton.Pushed":"스토어에 올렸습니다",
  
      "ListingModal.MainSection.Title":"제품 설명",
      "ListingModal.DetailsSection.Button.ProductVariations":"제품 옵션 열기",
      "ListingModal.DetailsSection.Button.OrderSamples":"샘플 주문",
      "ListingModal.DetailsSection.Button.OrderSamples.New":"신제품",
      "ListingModal.DetailsSection.BrandedInvoicing.Alert":"해당 제품에 브랜드 송장을 이용할 수 없습니다",
      "ListingModal.DetailsSection.InternationalShipping.Alert":"국제 주문은 중국의 물류센터에서 배송됩니다",
      "ListingModal.DetailsSection.StockUsa.Alert":"미국 물류센터에 재고가 없는 제품은 중국의 물류센터에서 발송될 수 있습니다",
      "ListingModal.DetailsSection.MultiplePackage.Alert":"주문 내역에 대한 전체 배송 기간을 단축하기 위해 여러 개로 나뉘어 발송될 수 있습니다",
      "ListingModal.DetailsSection.ConnectStore.Alert":"주문하려면 내 스토어를 연결하세요",
      "ListingModal.DetailsSection.PushedListButton":"스토어에 올렸습니다",
      "ListingModal.DetailsSection.RemoveListButton":"목록에서 제거",
      "ListingModal.DetailsSection.ImportListButton":"가져오기 목록에 추가",
      "ListingModal.DetailsSection.ImportListButton.Deactivated":"목록이 비활성화되었습니다",
  
      "InfoSection.ShippingTime.Tooltip": "제품 발송 후 배송 기간.",
      "InfoSection.ShippingTime.Title": "배송 기간",
      "InfoSection.ShippingInfo.Worldwide": "글로벌",
      "InfoSection.ShippingExcluded.Intro": "배송 불가 지역",
      "InfoSection.ShippingExcluded.Various": "여러 지역",
      "InfoSection.ProcessingTime.Tooltip": "공급업체에서 배송 및 배송 조회 번호를 제공하는 영업일 수",
      "InfoSection.ProcessingTime.Title": "처리 시간",
      "InfoSection.ProcessingTime.Period": "영업일",
      "InfoSection.ShippingInfoLine.Tooltip": "해당 제품의 배송비는 {{price_formatted}}이며, 동일한 주문 내의 각 추가 제품에 대해 {{incremental_price_formatted}}만큼 더해집니다",
      "InfoSection.ShippingInfoLine.Period": "영업일",
      "InfoSection.ShippingInfoLine.Free": "무료",
      "InfoSection.ShippingInfoLine.NoShipping": "배송 불가",
  
      "ReturnPolicySection.Title": "환불 정책",
  
      "TitleSection.TitleCountryOrigin.CountryOrigin.Intro": "발송지",
      "TitleSection.TitleCountryOrigin.SupplierShopName.Intro": "기준",
      "TitleSection.PriceMSRP.Listing": "표시가",
      "TitleSection.PriceMSRP.Retail": "소매가",
  
      "ProductVariationsModal.Title": "제품 옵션",
      "ProductVariationsModal.Table.Image": "이미지",
      "ProductVariationsModal.Table.Inventory": "재고",
      "ProductVariationsModal.Table.Price": "가격",
      "ProductVariationsModal.ImageSpecifications.Title": "사이즈 차트",
      "ProductVariationsModal.ImageSpecifications.Button": "다운로드",
  
      "TopSupplier.Tooltip": "인기 공급업체는 고품질 제품, 최상의 서비스, 높은 평가로 유명합니다",
      "TopSupplier.Text": "인기 공급업체",
  
      "BestSelling.SharedComponents.Text": "베스트셀러 제품",
      "BestSelling.Tooltip.Top": "Spocket의 최다 판매 제품입니다",
      "BestSelling.Tooltip.Bottom": "베스트셀러",
  
      "GallerySection.PremiumIcon.Tooltip": "내 쇼핑몰에서 할인율이 높으며 배송이 빠른 제품을 독점적으로 판매하세요",
      "GallerySection.PremiumIcon.Text": "프리미엄",
      "GallerySection.DiscountStamp.Text": "추가 {{value}}% 할인",
  
      "Upgrade.Title.AnnualToggled": "지금 Spocket 프리미엄 시작",
      "Upgrade.Title.MonthlyToggled": "14일 동안 Spocket 프리미엄을 무료로 사용해 보세요",
      "Upgrade.Subtitle": "지금 Spocket 프리미엄 플랜 구독을 시작하고 미국 및 유럽에서 전환율이 높은 제품을 내 스토어에 추가할 수 있습니다.",
      "Upgrade.Button": "Spocket 프리미엄 없이 진행",
  
      "Search.NoProductsFound.Title": "죄송합니다! 다음에 대한",
      "Search.NoProductsFound.For": "결과를 찾지 못했습니다",
      "Search.NoProductsFound.Description": "맞춤법을 확인하거나 관련 검색어 또는 보다 일반적인 검색어를 사용해 보세요.",
      "Search.Searching.Title": "제품 검색 중입니다...",
      "Search.Searching.Description": "최근 제품을 불러오는 동안 잠시만 기다려 주세요.",
  
      "Suppliers.StarRating.Tooltip": "공급업체 주문 처리 달성률",
      "Suppliers.RefundPolicy": "공급업체 환불 정책",
      "Suppliers.Joined.Title": "Spocket에 가입했습니다",
      "Suppliers.Origin.Title": "배송 국가",
      "Suppliers.Time.Title": "평균 배송 기간",
      "Suppliers.HasMore.Title": "제품 검색 중입니다...",
      "Suppliers.HasMore.Subtitle": "최근 제품을 불러오는 동안 잠시만 기다려 주세요.",
      "Suppliers.TopSupplierTag.Tooltip": "인기 공급업체는 고품질 제품, 최상의 서비스, 높은 평가로 유명합니다",
      "Suppliers.TopSupplierTag.Text": "인기 공급업체",
  
      "AltTextModal.Header.Title": "이미지 세부 정보 편집",
      "AltTextModal.Body.Description": "해당 이미지에 대한 간단한 설명을 추가하여 검색 엔진 최적화(SEO)를 수행하고 시각 장애 고객의 접근성을 개선할 수 있습니다.",
      "AltTextModal.Input.Label": "대체 텍스트",
      "AltTextModal.Input.Placeholder": "이미지 대체 텍스트",
      "AltTextModal.Button.Cancel": "취소",
      "AltTextModal.Button.Save": "저장",
  
      "WistiaModal.WhatIsSpocket.Title": "Spocket은 무엇인가요?",
      "WistiaModal.WhatIsSpocket.Text": "Spocket이 비즈니스 구축에 어떤 도움을 제공하는지 알아보세요. Spocket 사용 방법과 최상의 활용법을 이해해 보세요.",
      "WistiaModal.WhatIsSpocket.Button": "제품 검색 시작",
      "WistiaModal.DiscoverProducts.Title": "제품 검색",
      "WistiaModal.DiscoverProducts.Text": "적절한 필터를 활용해 적합한 제품을 찾아 내 스토어에 추가합니다.",
      "WistiaModal.DiscoverProducts.Button": "제품 검색 시작",
      "WistiaModal.ProductCustomization.Title": "제품 맞춤 설정",
      "WistiaModal.ProductCustomization.Text": "가져오기 목록을 사용해 내 스토어에 맞게 제품을 수정합니다. 제품 설명 편집, 가격 설정, 컬렉션에 제품 추가 및 이미지 제거 등을 수행할 수 있습니다.",
      "WistiaModal.ProductCustomization.Button": "가져오기 목록으로 이동",
      "WistiaModal.OrderProcessing.Title": "주문 처리 자동화",
      "WistiaModal.OrderProcessing.Text": "주문을 처리하고 클릭 한 번으로 공급업체가 고객의 문 앞까지 제품을 배송합니다.",
      "WistiaModal.OrderProcessing.Button": "주문 내역으로 이동",
      "WistiaModal.Settings.Title": "설정",
      "WistiaModal.Settings.Text": "설정 페이지에서 모든 계정 정보를 관리하고, 브랜드 송장을 만들고, 신용카드를 추가할 수 있습니다.  또한 모든 제품의 가격 설정 규칙을 조정하고 구독 플랜을 선택할 수도 있습니다.",
      "WistiaModal.Settings.Button": "계정 설정"
  }
};



// WEBPACK FOOTER //
// ./src/utils/i18n/ko.js